module.exports = __webpack_public_path__ + "static/media/hand.de574cf6.png";